import { render, staticRenderFns } from "./StickyDate.vue?vue&type=template&id=ec2d7c04&scoped=true&"
import script from "./StickyDate.vue?vue&type=script&lang=js&"
export * from "./StickyDate.vue?vue&type=script&lang=js&"
import style0 from "./StickyDate.vue?vue&type=style&index=0&id=ec2d7c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2d7c04",
  null
  
)

export default component.exports